/* eslint-disable no-empty-pattern */
import roundHistoryService from '@/services/roundHistory.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		roundHistories: [],
		roundHistory: {},
		activeRound: {},
		searchParams: {
			customerId: '',
			done: null,
			orderBy: '',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_HISTORIES(state, roundHistories) {
			state.roundHistories = roundHistories;
		},
		SET_HISTORY(state, roundHistory) {
			state.roundHistory = roundHistory;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		SET_ACTIVEROUND(state, activeRound) {
			state.activeRound = activeRound;
		}
	},

	actions: {
		async getRoundHistory({ commit, dispatch }, roundHistoryId) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundHistoryService
				.getRoundHistory(roundHistoryId)
				.then(data => {
					commit('SET_HISTORY', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roundHistory: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundHistories({ commit, dispatch }, buildingId) {
			dispatch('appStore/setLoading', 1, { root: true });

			try {
				const response = await roundHistoryService.getAllRoundHistory(buildingId);
				console.log(response);
				return response;
			} catch (err) {
				console.error('Error fetching round histories:', err);
				throw err; // så att komponenten kan fånga det i .catch
			} finally {
				dispatch('appStore/setLoading', -1, { root: true });
			}
		},

		async getActiveRoundHistoryByPlanningId(
			{ commit, dispatch },
			roundPlanningId
		) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await roundHistoryService
				.getRoundHistories({
					done: false,
					roundPlanningId
				})
				.then(data => {
					dispatch('appStore/setLoading', -1, { root: true });

					commit('SET_HISTORY', data[0]);
				});
		},
		async createRoundHistory({ dispatch }, roundHistory) {
			return await roundHistoryService
				.createRoundHistory(roundHistory)
				.then(() => {
					dispatch('getRoundHistories');
				})
				.catch(err => {
					console.log('Error creating roundHistory: ', err);
				});
		},
		async updateRoundHistory({}, roundHistory) {
			return await roundHistoryService
				.updateRoundHistory(roundHistory)
				.catch(err => {
					console.log('Error updating roundHistory: ', err);
					throw err;
				});
		},
		async deleteRoundHistory({ dispatch }, roundHistory) {
			return await roundHistoryService
				.deleteRoundHistory(roundHistory.id)
				.then(() => {
					dispatch('getRoundHistories');
				})
				.catch(err => {
					console.log('Error deleting roundHistory: ', err);
				});
		},

		setRoundHistory({ commit }, roundHistory) {
			commit('SET_HISTORY', roundHistory);
		},
		setRoundHistories({ commit }, roundHistories) {
			commit('SET_HISTORIES', roundHistories);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		roundHistory: state => {
			return state.roundHistory;
		},
		roundHistories: state => {
			return state.roundHistories.filter(roundhistory => {
				return !roundhistory.done;
			}, []);
		},
		activeRound: state => {
			return state.activeRound;
		},
		getDoneRoundHistories: state => {
			return state.roundHistories.filter(roundhistory => {
				return !!roundhistory.done;
			}, []);
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
